import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';
const JENIS_LIST = ['Akta', 'NIB', 'NPWP', 'Izin', 'Kontrak', 'Lainnya'];

export default function DokumenLegal({ companyId }) {
  const [docs, setDocs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [jenis, setJenis] = useState('Akta');
  const [keteranganLainnya, setKeteranganLainnya] = useState('');
  const [catatan, setCatatan] = useState('');
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { loadDocs(); }, [companyId]);

  const loadDocs = async () => {
    try {
      const params = companyId ? { company_id: companyId } : {};
      const res = await axios.get(`${API}/api/documents`, { params });
      setDocs(res.data);
    } catch {}
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return;
    setUploading(true); setMsg('');
    try {
      const fd = new FormData();
      fd.append('jenis', jenis);
      if (keteranganLainnya) fd.append('keterangan_lainnya', keteranganLainnya);
      if (catatan) fd.append('catatan', catatan);
      if (companyId) fd.append('company_id_param', companyId);
      fd.append('file', file);
      await axios.post(`${API}/api/documents/upload`, fd);
      setMsg('Dokumen berhasil diupload!');
      setShowForm(false); setFile(null); setJenis('Akta'); setCatatan(''); setKeteranganLainnya('');
      loadDocs();
    } catch {
      setMsg('Gagal upload dokumen');
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Hapus dokumen ini?')) return;
    await axios.delete(`${API}/api/documents/${id}`);
    loadDocs();
  };

  const handleView = async (docId, originalFilename) => {
    try {
      const token = localStorage.getItem('ptgpb_token');
      const res = await fetch(`${API}/api/documents/${docId}/file`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Gagal membuka file');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch {
      alert('Gagal membuka file');
    }
  };

  if (companyId === null) {
    return <div style={s.empty}>Pilih perusahaan terlebih dahulu dari menu "Semua Perusahaan"</div>;
  }

  return (
    <div>
      <div style={s.header}>
        <h2 style={s.h2}>📄 Dokumen Legal</h2>
        <button style={s.addBtn} onClick={() => setShowForm(!showForm)}>+ Upload Dokumen</button>
      </div>

      {msg && <div style={{ ...s.msg, color: msg.includes('berhasil') ? '#16a34a' : '#dc2626' }}>{msg}</div>}

      {showForm && (
        <div style={s.formCard}>
          <h3 style={s.formTitle}>Upload Dokumen Baru</h3>
          <form onSubmit={handleUpload}>
            <div style={s.row}>
              <div style={{ flex: 1 }}>
                <label style={s.label}>Jenis Berkas</label>
                <select style={s.input} value={jenis} onChange={e => setJenis(e.target.value)}>
                  {JENIS_LIST.map(j => <option key={j}>{j}</option>)}
                </select>
              </div>
              {jenis === 'Lainnya' && (
                <div style={{ flex: 1 }}>
                  <label style={s.label}>Keterangan</label>
                  <input style={s.input} value={keteranganLainnya} onChange={e => setKeteranganLainnya(e.target.value)} placeholder="Nama berkas..." required />
                </div>
              )}
            </div>
            <div style={s.field}>
              <label style={s.label}>Upload File</label>
              <input type="file" style={s.input} onChange={e => setFile(e.target.files[0])} required />
            </div>
            <div style={s.field}>
              <label style={s.label}>Catatan (opsional)</label>
              <textarea style={{ ...s.input, height: '70px', resize: 'vertical' }} value={catatan} onChange={e => setCatatan(e.target.value)} placeholder="Catatan..." />
            </div>
            <div style={s.formActions}>
              <button type="button" style={s.cancelBtn} onClick={() => setShowForm(false)}>Batal</button>
              <button type="submit" style={s.saveBtn} disabled={uploading}>{uploading ? 'Mengupload...' : 'Upload'}</button>
            </div>
          </form>
        </div>
      )}

      {docs.length === 0 ? (
        <div style={s.empty}>Belum ada dokumen. Klik "Upload Dokumen" untuk menambahkan.</div>
      ) : (
        <div style={s.tableWrap}>
          <table style={s.table}>
            <thead>
              <tr style={s.thead}>
                <th style={s.th}>Jenis</th>
                <th style={s.th}>Nama File</th>
                <th style={s.th}>Versi</th>
                <th style={s.th}>Catatan</th>
                <th style={s.th}>Tanggal</th>
                <th style={s.th}>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {docs.map(d => (
                <tr key={d.id} style={s.tr}>
                  <td style={s.td}>
                    <span style={s.badge}>{d.jenis}</span>
                    {d.keterangan_lainnya && <span style={s.subtext}> ({d.keterangan_lainnya})</span>}
                  </td>
                  <td style={s.td}>{d.original_filename}</td>
                  <td style={s.td}><span style={s.verBadge}>v{d.version}</span></td>
                  <td style={s.td}>{d.catatan || '-'}</td>
                  <td style={s.td}>{new Date(d.created_at).toLocaleDateString('id-ID')}</td>
                  <td style={s.td}>
                    <button style={s.viewBtn} onClick={() => handleView(d.id, d.original_filename)}>Lihat</button>
                    <button style={s.delBtn} onClick={() => handleDelete(d.id)}>Hapus</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  h2: { fontSize: '20px', fontWeight: '700', color: '#1a1a2e', margin: 0 },
  addBtn: { padding: '8px 18px', background: '#1a1a2e', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
  msg: { padding: '10px 14px', background: '#f0fdf4', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  formTitle: { fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#1a1a2e' },
  row: { display: 'flex', gap: '12px', marginBottom: '12px' },
  field: { marginBottom: '12px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '5px' },
  input: { width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  formActions: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  cancelBtn: { padding: '8px 18px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  saveBtn: { padding: '8px 18px', background: '#1a1a2e', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' },
  tableWrap: { background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  thead: { background: '#f9fafb' },
  th: { padding: '12px 14px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#6b7280', borderBottom: '1px solid #e5e7eb' },
  tr: { borderBottom: '1px solid #f3f4f6' },
  td: { padding: '12px 14px', fontSize: '14px', color: '#374151' },
  badge: { background: '#eff6ff', color: '#1d4ed8', borderRadius: '4px', padding: '2px 8px', fontSize: '12px', fontWeight: '600' },
  subtext: { fontSize: '12px', color: '#6b7280' },
  verBadge: { background: '#f0fdf4', color: '#16a34a', borderRadius: '4px', padding: '2px 8px', fontSize: '12px', fontWeight: '600' },
  viewBtn: { padding: '4px 10px', background: '#eff6ff', color: '#1d4ed8', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', marginRight: '6px' },
  delBtn: { padding: '4px 10px', background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  empty: { background: 'white', borderRadius: '12px', padding: '40px', textAlign: 'center', color: '#9ca3af', fontSize: '14px' }
};
